export const personal = {
  name: "Vishvjeet Rana",
  handle: "@RVishvjeet_",
  role: "Full Stack Developer",
  tagline: "Building production-grade AI-powered applications.",
  subTagline: "Open to remote opportunities worldwide.",
  bio: "Full-stack developer with production experience building AI-powered applications and a passion for developer experience. Experienced with frontier AI models and LLM-assisted workflows using Claude Code, Cursor, ChatGPT, and GitHub Copilot. Strong at translating complex technical concepts into practical, scalable user-facing products.",
  email: "vishvjeet.rana7@gmail.com",
  location: "Mohali, Punjab",
  version: "VR:02",
  socials: {
    x: "https://x.com/RVishvjeet_/",
    github: "https://github.com/Vishvjeet-Rana/",
    linkedin: "https://www.linkedin.com/in/vishvjeet-rana/",
    medium: "https://vishvjeetrana.medium.com/",
    hashnode: "https://vishvjeetrana.hashnode.dev/",
  },
  education: {
    institution: "Kurukshetra University",
    degree: "B.Sc. Information Technology",
    period: "Aug. 2020 – Jun. 2023",
    cgpa: "8.5 / 10",
    achievements: [
      "Rank 1 — college batch",
      "Rank 3 — university-wide in B.Sc. IT results",
    ],
  },
  stats: [
    { label: "Years Experience", value: "1+" },
    { label: "CGPA", value: "8.5" },
    { label: "University Rank", value: "#3" },
    { label: "Production Apps", value: "3" },
  ],
};
